<template>
	<div style="min-height: 75vh">

	<div v-if="myPayoutData.length > 0">
		<div class="my-reward-list__container">
			<MyRewardTile v-for="payout in myPayoutData" :key="payout.id" :id="payout.id"
				@click="tileClicked(payout)" />
		</div>
	</div>



	<div v-if="loadingMyPayoutData">
		<div class="my-reward-list__container">
			<v-skeleton-loader :elevation="4" type="list-item-avatar-three-line" v-for="n in 20" :key="n"
				color="var(--v-skeleton-loader-color)">
			</v-skeleton-loader>
		</div>
	</div>



	<EmptyList class="mx-auto mt-4" v-if="myPayoutData.length === 0">
		<template v-slot:title>
			Sorry, you haven't withdrawn any rewards yet.
		</template>
	</EmptyList>


	<Pagination 
		:model-value="pageNumber"
		@update:model-value="(value) => pageNumber = value"
		:length="pageLength" 
		:total-visible="totalVisible"
	/>


	<MyRewardDialog></MyRewardDialog>
	</div>
</template>



<script setup>

import { PayoutStore } from "@/store/PayoutStore";
import MyRewardDialog from "./MyReward-Dialog.vue";
import { computed, ref, provide } from "vue";
import EmptyList from "@/components/Common/Empty-List.vue";
import Pagination from "@/components/Common/Pagination.vue";
import MyRewardTile from "@/components/Tiles/Rewards/MyReward-Tile.vue";
import { usePagination } from "@/composables/usePagination";

let openDialog = ref(false);
provide("openDialog", openDialog);

const payoutStore = PayoutStore();
const myPayoutData = computed(() => payoutStore.MyPayoutData);
const loadingMyPayoutData = computed(() => payoutStore.loadingMyPayoutData);

// Use the pagination composable to handle pagination logic
const { pageNumber, pageLength, totalVisible } = usePagination({
	store: payoutStore,
	getTotalPages: (store) => store.MyPayoutDataPaging.totalPages,
	getCurrentPage: (store) => store.MyPayoutDataPaging.page,
	setPage: (store, page) => store.setMyPayoutsPage(page),
	fetchData: async (store) => await store.getMyPayoutData()
});

const tileClicked = (payout) => {
	openDialog.value = true;
}

// totalVisible is now provided by the usePagination composable
</script>



<style scoped lang="scss">
@use "@/assets/scss/button-mixins" as button-mixins;
</style>